

import React, { memo } from 'react';
import ReactTooltip from 'react-tooltip';
import cx from 'classnames';
import appendToBody from '../../common/hoc/appendToBody';
import './_tooltip.scss';










const TooltipBase = (
{
  id,
  label,
  place,
  className,
  TooltipOtherProps






}) =>

<ReactTooltip
  id={id}
  effect="solid"
  delayShow={300}
  className={cx('tooltip', className)}
  place={place}
  {...TooltipOtherProps}>

    <span className="text text--caption text--dark-theme text--no-margin">{label}</span>
  </ReactTooltip>;


const BodyTooltip = appendToBody(TooltipBase);

function ToolTip({ label, id, place, className, children, TooltipOtherProps = {} }) {
  if (!id || !label) {return children;}

  return (
    <>
      <BodyTooltip
        id={id}
        label={label}
        effect="solid"
        place={place}
        className={className}
        TooltipOtherProps={TooltipOtherProps} />

      {React.cloneElement(children, { 'data-tip': true, 'data-for': id })}
    </>);

}

export default memo(ToolTip);